export default {
  label: "示例图",
  type: "example",
  property: "",
  value: "",
};
